module.exports = __webpack_public_path__ + "images/minimalistic-2fbee94a7ef8c3fa6173c2bd5b8a7e6d.jpg";